import { REGEX_PATTERNS } from '@constants';
import * as yup from 'yup';

export const addValidationSchema = yup.object({
  contract: yup.string().required('Required'),
  firstName: yup.string().required('Required'),
  lastName: yup.string().required('Required'),
  vat: yup.string().required('Required'),
  doi: yup.string().required('Required'),
  activity: yup.string().required('Required'),
  phoneNumber: yup.string().required('Required').matches(REGEX_PATTERNS.Phone),
  email: yup.string().required('Required').matches(REGEX_PATTERNS.Email),
  address: yup.string().required('Required'),
  postalCode: yup.string().required('Required'),
  // companyName: yup.string().required('Required'),
  companyName: yup.string().when('contract', {
    is: (contract) => {
      return contract === 'Ιδιώτης';
    },
    then: () => yup.string().notRequired(),
    otherwise: () => yup.string().required('Required'),
  }),
});

export const editValidationSchema = yup.object({
  firstName: yup.string().required('Required'),
  lastName: yup.string().required('Required'),
  vat: yup.string().required('Required'),
  doi: yup.string().required('Required'),
  activity: yup.string().required('Required'),
  phoneNumber: yup.string().required('Required').matches(REGEX_PATTERNS.Phone),
  email: yup.string().required('Required').matches(REGEX_PATTERNS.Email),
  address: yup.string().required('Required'),
  postalCode: yup.string().required('Required'),
  // companyName: yup.string().required('Required'),
  companyName: yup.string().when('contract', {
    is: (contract) => {
      return contract === 'Ιδιώτης';
    },
    then: () => yup.string().notRequired(),
    otherwise: () => yup.string().required('Required'),
  }),
});
